const Hammer = require('hammerjs')

module.exports = function ($el, action) {
  const $shortcuts = $el.find('.slider-shortcuts input'),
    $inputs = $el.find('.slider-inputs input')

  $inputs.on('change', function(){
    const index = $(this).val()
    action(index)
    $shortcuts.eq(index).prop('checked', true)
  })

  $shortcuts.on('change', function(){
    const index = $(this).val()
    action(index)
    $inputs.eq(index).prop('checked', true)
  })

  function show_next () {
    const index = $inputs.filter(':checked').val()
    $inputs.eq((Number.parseInt(index) + 1) % $inputs.length).click()
  }

  function show_prev () {
    const index = $inputs.filter(':checked').val()
    $inputs.eq((Number.parseInt(index) - 1) % $inputs.length).click()
  }

  const el = $el.get(0)
  if (el) {
    new Hammer(el)
      .on('swiperight', show_prev)
      .on('swipeleft', show_next)
  }

  // Initialize

  $inputs.eq(0).trigger('click')
}
